/**
 * FaceSwap 智能提示词映射配置
 * 与 options 文件保持完全一致的键值映射
 */

// 技术参数映射 - 对应 CameraOptions.js
export const technicalParameterMappings = {
  // 相机类型
  camera_type: {
    "Full-frame DSLR": "full-frame DSLR camera",
    "APS-C Camera": "APS-C camera",
    "Mirrorless Camera": "mirrorless camera",
    "Medium Format Camera": "medium format camera",
    "Point-and-shoot Camera": "point-and-shoot camera",
    "Phone Camera": "smartphone camera"
  },
  
  // 镜头类型
  lens_type: {
    "Standard lens (50mm f/1.8)": "standard 50mm f/1.8 lens",
    "Wide-angle lens (35mm, 24mm)": "wide-angle lens",
    "Medium telephoto lens (85mm, 105mm)": "medium telephoto lens",
    "Telephoto lens (200mm, 300mm)": "telephoto lens",
    "Macro lens": "macro lens",
    "Fisheye lens": "fisheye lens",
    "Zoom lens (24-70mm, 70-200mm)": "zoom lens",
    "Prime lens (35mm, 50mm, 85mm)": "prime lens",
    "Large aperture lens (f/1.2, f/1.4)": "large aperture lens"
  },
  
  // 焦距
  focal_length: {
    "Ultra-wide angle (10mm-24mm)": "ultra-wide angle 10-24mm",
    "Wide angle (35mm, 50mm)": "wide angle 35-50mm",
    "Standard (85mm, 105mm)": "standard 85-105mm",
    "Telephoto (200mm, 300mm)": "telephoto 200-300mm",
    "Super-telephoto (400mm, 600mm)": "super-telephoto 400-600mm"
  },
  
  // 光圈
  aperture: {
    "Large aperture (f/1.2, f/1.4)": "large aperture f/1.2-f/1.4",
    "Medium aperture (f/2.8, f/3.5)": "medium aperture f/2.8-f/3.5",
    "Small aperture (f/8, f/11)": "small aperture f/8-f/11"
  },
  
  // 快门速度
  shutter_speed: {
    "Fast shutter (1/1000s, 1/500s)": "fast shutter 1/1000s",
    "Medium shutter (1/250s, 1/125s)": "medium shutter 1/250s",
    "Slow shutter (1/60s, 1/30s)": "slow shutter 1/60s"
  },
  
  // ISO
  iso: {
    "Low ISO (100-400)": "low ISO 100-400",
    "Medium ISO (800-1600)": "medium ISO 800-1600",
    "High ISO (3200-6400)": "high ISO 3200-6400"
  },
  
  // 白平衡
  white_balance: {
    "Auto": "auto white balance",
    "Daylight": "daylight white balance",
    "Cloudy": "cloudy white balance",
    "Tungsten": "tungsten white balance",
    "Fluorescent": "fluorescent white balance",
    "Custom": "custom white balance"
  },
  
  // 对焦模式
  focus_mode: {
    "Single-point AF": "single-point autofocus",
    "Zone AF": "zone autofocus",
    "Auto AF": "auto autofocus",
    "Face detection AF": "face detection autofocus",
    "Tracking AF": "tracking autofocus",
    "Manual focus": "manual focus"
  },
  
  // 曝光模式
  exposure_mode: {
    "Auto exposure": "auto exposure",
    "Shutter priority": "shutter priority mode",
    "Aperture priority": "aperture priority mode",
    "Manual exposure": "manual exposure",
    "Exposure compensation": "exposure compensation"
  },
  
  // 拍摄模式
  shooting_mode: {
    "Single shot": "single shot mode",
    "Burst mode": "burst mode",
    "Time-lapse": "time-lapse mode",
    "Super slow-motion": "super slow-motion mode"
  },
  
  // 拍摄角度
  shooting_angle: {
    "High angle (looking down)": "high angle shot, looking down",
    "Low angle (looking up)": "low angle shot, looking up",
    "Front view": "front view",
    "Side view": "side view",
    "45-degree angle": "45-degree angle"
  },
  
  // 姿势
  pose: {
    "Power Pose": "power pose",
    "Walking Pose": "walking pose",
    "S-curve Pose": "S-curve pose",
    "Sitting Pose": "sitting pose",
    "Leaning Pose": "leaning pose",
    "Headshot Pose": "headshot pose",
    "Hand-on-Hip Pose": "hand-on-hip pose",
    "Candid Laugh Pose": "candid laugh pose",
    "High Fashion Pose": "high fashion pose"
  }
};

// 风格和情绪映射 - 对应 StyleOptions.js
export const styleAndMoodMappings = {
  // 拍摄类型
  shot_type: {
    "Portrait": "portrait shot",
    "Head portrait": "head portrait",
    "Head and shoulders portrait": "head and shoulders portrait",
    "Half-length portrait": "half-length portrait",
    "Full-length portrait": "full-length portrait",
    "Face": "face shot",
    "Close-up": "close-up shot"
  },
  
  // 成像风格
  imaging_style: {
    "Standard mode": "standard imaging style",
    "High contrast mode": "high contrast style",
    "Landscape mode": "landscape style",
    "Portrait mode": "portrait style",
    "Black and white mode": "black and white style",
    "Clarity enhancement": "clarity enhanced style"
  },
  
  // 艺术风格
  artistic_style: {
    "Realistic style": "realistic style",
    "Illustration style": "illustration style",
    "Cartoon style": "cartoon style",
    "Watercolor style": "watercolor style",
    "Vintage style": "vintage style",
    "Steampunk style": "steampunk style"
  },
  
  // 艺术效果
  art_effect: {
    "Oil painting effect": "oil painting effect",
    "Ink wash painting effect": "ink wash painting effect",
    "Sketch effect": "sketch effect",
    "Colored pencil effect": "colored pencil effect"
  },
  
  // 景深
  depth_of_field: {
    "Shallow depth of field": "shallow depth of field",
    "Medium depth of field": "medium depth of field",
    "Deep depth of field": "deep depth of field"
  },
  
  // 照片效果
  photo_effect: {
    "Aspect ratio crop (1:1, 16:9)": "aspect ratio crop",
    "Vintage style": "vintage photo effect",
    "HDR (High Dynamic Range)": "HDR effect",
    "Film effect": "film effect",
    "Hard and soft light": "hard and soft light effect",
    "Long exposure effect": "long exposure effect"
  },
  
  // 特殊效果
  special_effect: {
    "Low saturation": "low saturation",
    "High contrast": "high contrast",
    "High Dynamic Range (HDR)": "HDR effect",
    "Duotone effect": "duotone effect",
    "Fluorescent/Neon style": "fluorescent neon style"
  },
  
  // 后期处理风格
  post_processing_style: {
    "Filter (vintage, B&W, film)": "vintage filter",
    "Sharpening": "sharpening effect",
    "Denoise": "denoise effect",
    "Color correction": "color correction",
    "Film grain": "film grain effect"
  }
};

// 角色特征映射 - 对应 RoleOptions.js
export const characterMappings = {
  // 性别
  gender: {
    "Man": "man",
    "Woman": "woman"
  },
  
  // 年龄
  age: {
    "Baby (0-2)": "baby, 0-2 years old",
    "Child (3-12)": "cute child, 3-12 years old",
    "Teenager (13-19)": "teenager, 13-19 years old",
    "Young Adult (20-39)": "young adult, 20-39 years old",
    "Middle-aged (40-59)": "middle-aged, 40-59 years old",
    "Senior (60+)": "senior, 60+ years old"
  },
  
  // 表情
  expression: {
    "Happy": "happy expression",
    "Laughing": "laughing expression",
    "Serious": "serious expression",
    "Calm": "calm expression",
    "Surprised": "surprised expression",
    "Sad": "sad expression",
    "Angry": "angry expression",
    "Thoughtful": "thoughtful expression"
  },
  
  // 眼睛颜色
  eye_color: {
    "Black": "black eyes",
    "Brown": "brown eyes",
    "Blue": "blue eyes",
    "Green": "green eyes",
    "Gray": "gray eyes",
    "Hazel": "hazel eyes"
  },
  
  // 发型
  hair_style: {
    "Buzz cut": "buzz cut",
    "Crew cut": "crew cut",
    "Pixie cut": "pixie cut",
    "Bob cut": "bob cut",
    "Shoulder-length": "shoulder-length hair",
    "Long straight": "long straight hair",
    "Long wavy": "long wavy hair",
    "Curly": "curly hair",
    "Afro": "afro hair",
    "Ponytail": "ponytail",
    "High bun": "high bun",
    "Low bun": "low bun",
    "Bald": "bald"
  },
  
  // 发色
  hair_color: {
    "Black": "black hair",
    "Dark brown": "dark brown hair",
    "Light brown": "light brown hair",
    "Blonde": "blonde hair",
    "Platinum blonde": "platinum blonde hair",
    "Red": "red hair",
    "Auburn": "auburn hair",
    "Gray": "gray hair",
    "White": "white hair",
    "Colorful": "colorful hair"
  },
  
  // 胡须
  beard: {
    "Clean shaven": "clean shaven",
    "5 o'clock shadow": "5 o'clock shadow",
    "Light stubble": "light stubble",
    "Heavy stubble": "heavy stubble",
    "Goatee": "goatee",
    "Van Dyke": "Van Dyke beard",
    "Full beard": "full beard",
    "Handlebar mustache": "handlebar mustache",
    "Pencil mustache": "pencil mustache"
  },
  
  // 国籍
  nationality: {
    "Afghan": "Afghan person",
    "Albanian": "Albanian person",
    "Algerian": "Algerian person",
    "American": "American person",
    "Andorran": "Andorran person",
    "Angolan": "Angolan person",
    "Argentine": "Argentine person",
    "Armenian": "Armenian person",
    "Australian": "Australian person",
    "Austrian": "Austrian person",
    "Azerbaijani": "Azerbaijani person",
    "Bahamian": "Bahamian person",
    "Bahraini": "Bahraini person",
    "Bangladeshi": "Bangladeshi person",
    "Barbadian": "Barbadian person",
    "Belarusian": "Belarusian person",
    "Belgian": "Belgian person",
    "Belizean": "Belizean person",
    "Beninese": "Beninese person",
    "Bhutanese": "Bhutanese person",
    "Bolivian": "Bolivian person",
    "Brazilian": "Brazilian person",
    "British": "British person",
    "Bruneian": "Bruneian person",
    "Bulgarian": "Bulgarian person",
    "Burkinabe": "Burkinabe person",
    "Burundian": "Burundian person",
    "Cambodian": "Cambodian person",
    "Cameroonian": "Cameroonian person",
    "Canadian": "Canadian person",
    "Cape Verdian": "Cape Verdian person",
    "Chadian": "Chadian person",
    "Chilean": "Chilean person",
    "Chinese": "Chinese person",
    "Colombian": "Colombian person",
    "Congolese": "Congolese person",
    "Costa Rican": "Costa Rican person",
    "Croatian": "Croatian person",
    "Cuban": "Cuban person",
    "Cypriot": "Cypriot person",
    "Czech": "Czech person",
    "Danish": "Danish person",
    "Dominican": "Dominican person",
    "Dutch": "Dutch person",
    "Ecuadorean": "Ecuadorean person",
    "Egyptian": "Egyptian person",
    "Emirian": "Emirian person",
    "Estonian": "Estonian person",
    "Ethiopian": "Ethiopian person",
    "Fijian": "Fijian person",
    "Filipino": "Filipino person",
    "Finnish": "Finnish person",
    "French": "French person",
    "Gabonese": "Gabonese person",
    "Gambian": "Gambian person",
    "Georgian": "Georgian person",
    "German": "German person",
    "Ghanaian": "Ghanaian person",
    "Greek": "Greek person",
    "Guatemalan": "Guatemalan person",
    "Guinean": "Guinean person",
    "Haitian": "Haitian person",
    "Honduran": "Honduran person",
    "Hungarian": "Hungarian person",
    "Icelander": "Icelander person",
    "Indian": "Indian person",
    "Indonesian": "Indonesian person",
    "Iranian": "Iranian person",
    "Iraqi": "Iraqi person",
    "Irish": "Irish person",
    "Israeli": "Israeli person",
    "Italian": "Italian person",
    "Ivorian": "Ivorian person",
    "Jamaican": "Jamaican person",
    "Japanese": "Japanese person",
    "Jordanian": "Jordanian person",
    "Kazakhstani": "Kazakhstani person",
    "Kenyan": "Kenyan person",
    "North Korean": "North Korean person",
    "South Korean": "South Korean person",
    "Kuwaiti": "Kuwaiti person",
    "Kyrgyz": "Kyrgyz person",
    "Laotian": "Laotian person",
    "Latvian": "Latvian person",
    "Lebanese": "Lebanese person",
    "Liberian": "Liberian person",
    "Libyan": "Libyan person",
    "Lithuanian": "Lithuanian person",
    "Luxembourgish": "Luxembourgish person",
    "Macedonian": "Macedonian person",
    "Malagasy": "Malagasy person",
    "Malawian": "Malawian person",
    "Malaysian": "Malaysian person",
    "Maldivan": "Maldivan person",
    "Malian": "Malian person",
    "Maltese": "Maltese person",
    "Mauritanian": "Mauritanian person",
    "Mauritian": "Mauritian person",
    "Mexican": "Mexican person",
    "Moldovan": "Moldovan person",
    "Mongolian": "Mongolian person",
    "Montenegrin": "Montenegrin person",
    "Moroccan": "Moroccan person",
    "Mozambican": "Mozambican person",
    "Namibian": "Namibian person",
    "Nepalese": "Nepalese person",
    "New Zealander": "New Zealander person",
    "Nicaraguan": "Nicaraguan person",
    "Nigerian": "Nigerian person",
    "Norwegian": "Norwegian person",
    "Pakistani": "Pakistani person",
    "Panamanian": "Panamanian person",
    "Paraguayan": "Paraguayan person",
    "Peruvian": "Peruvian person",
    "Polish": "Polish person",
    "Portuguese": "Portuguese person",
    "Qatari": "Qatari person",
    "Romanian": "Romanian person",
    "Russian": "Russian person",
    "Rwandan": "Rwandan person",
    "Salvadoran": "Salvadoran person",
    "Saudi": "Saudi person",
    "Scottish": "Scottish person",
    "Senegalese": "Senegalese person",
    "Serbian": "Serbian person",
    "Singaporean": "Singaporean person",
    "Slovakian": "Slovakian person",
    "Slovenian": "Slovenian person",
    "Somali": "Somali person",
    "South African": "South African person",
    "Spanish": "Spanish person",
    "Sri Lankan": "Sri Lankan person",
    "Sudanese": "Sudanese person",
    "Swedish": "Swedish person",
    "Swiss": "Swiss person",
    "Syrian": "Syrian person",
    "Thai": "Thai person",
    "Togolese": "Togolese person",
    "Tunisian": "Tunisian person",
    "Turkish": "Turkish person",
    "Ugandan": "Ugandan person",
    "Ukrainian": "Ukrainian person",
    "Uruguayan": "Uruguayan person",
    "Uzbekistani": "Uzbekistani person",
    "Venezuelan": "Venezuelan person",
    "Vietnamese": "Vietnamese person",
    "Welsh": "Welsh person",
    "Yemeni": "Yemeni person",
    "Zambian": "Zambian person",
    "Zimbabwean": "Zimbabwean person"
  },
  
  // 体重
  body_weight: {
    "Underweight": "underweight",
    "Normal weight": "normal weight",
    "Overweight": "overweight",
    "Obese": "obese"
  },
  
  // 脸型
  face_shape: {
    "Oval": "oval face",
    "Round": "round face",
    "Square": "square face",
    "Heart-shaped": "heart-shaped face",
    "Long": "long face",
    "Rectangle": "rectangle face",
    "Triangle": "triangle face",
    "Inverted Triangle": "inverted triangle face",
    "Pear-shaped": "pear-shaped face",
    "Oblong": "oblong face"
  },
  
  // 面部特征细节
  facial_feature_details: {
    "High nose bridge": "high nose bridge",
    "Short nose": "short nose",
    "Large eyes": "large eyes",
    "Small eyes": "small eyes",
    "High cheekbones": "high cheekbones",
    "Small mouth": "small mouth",
    "Full lips": "full lips",
    "Perfect teeth": "perfect teeth",
    "Squint": "squint",
    "Natural expression": "natural expression"
  },
  
  // 眼部特征
  eye_features: {
    "Double eyelids": "double eyelids",
    "Single eyelids": "single eyelids",
    "Inner double eyelids": "inner double eyelids",
    "Deep-set eyes": "deep-set eyes",
    "Bags under eyes": "bags under eyes",
    "Eyeshadow effect": "eyeshadow effect",
    "Eyeliner": "eyeliner"
  },
  
  // 耳朵
  ears: {
    "Visible ears": "visible ears",
    "Hidden ears": "hidden ears",
    "Large ears": "large ears",
    "Small ears": "small ears",
    "Pierced ears": "pierced ears",
    "Earrings": "earrings"
  },
  
  // 皮肤细节
  skin_details: {
    "Smooth skin": "smooth skin",
    "Spotted skin": "spotted skin",
    "Dull skin": "dull skin",
    "Healthy glow": "healthy glow",
    "Natural skin tone": "natural skin tone",
    "Acne/Freckles": "acne freckles",
    "Wrinkles/Aged look": "wrinkles aged look"
  },
  
  // 皮肤纹理效果
  skin_texture_effect: {
    "Flawless skin": "flawless skin",
    "Textured skin": "textured skin",
    "Matte skin": "matte skin",
    "Glossy skin": "glossy skin",
    "Enhanced detail texture": "enhanced detail texture"
  },
  
  // 服装风格
  clothing_style: {
    "Formal wear": "formal wear",
    "Suit": "suit, business suit, formal suit",
    "Business attire": "business attire, professional clothing",
    "Evening attire": "formal evening attire, elegant formal wear",
    "Casual wear": "casual wear",
    "Sportswear": "sportswear",
    "Uniform": "uniform, professional uniform",
    "Wedding attire": "wedding attire, ceremonial wedding clothing",
    "Traditional costume": "traditional costume",
    "Vintage/Retro clothing": "vintage retro clothing"
  },
  
  // 服装质感
  clothing_texture: {
    "Silk/Glossy texture": "silk glossy texture",
    "Sweater texture": "sweater texture",
    "Leather texture": "leather texture",
    "Printed pattern": "printed pattern",
    "Denim texture": "denim texture"
  },
  
  // 头部配饰
  head_accessories: {
    "Hat": "hat",
    "Glasses": "glasses",
    "Jewelry": "jewelry",
    "Hair accessories": "hair accessories",
    "Face accessories": "face accessories"
  }
};

// 环境和光照映射 - 对应 EnvOptions.js
export const environmentMappings = {
  // 环境氛围
  environment_atmosphere: {
    "warm_sunlight": "warm sunlight atmosphere",
    "cool_tone": "cool tone atmosphere",
    "dark_atmosphere": "dark atmosphere",
    "cloudy_hazy": "cloudy hazy atmosphere",
    "light_through_window": "light through window"
  },
  
  // 光线风格
  light_style: {
    "natural_sunlight": "natural sunlight",
    "soft_ambient_light": "soft ambient light",
    "harsh_sunlight": "harsh sunlight",
    "overcast_sky": "overcast sky lighting",
    "sunset_glow": "sunset glow",
    "candlelight": "candlelight",
    "moonlight": "moonlight",
    "backlit_silhouette": "backlit silhouette",
    "spotlight": "spotlight",
    "rim_lighting": "rim lighting",
    "studio_lighting": "studio lighting",
    "golden_hour_light": "golden hour light",
    "blue_hour_light": "blue hour light",
    "neon_lights": "neon lights"
  },
  
  // 光线方向
  light_direction: {
    "from_top": "light from top",
    "from_bottom": "light from bottom",
    "from_right": "light from right",
    "from_left": "light from left",
    "from_front": "light from front",
    "from_top_right": "light from top right",
    "from_top_left": "light from top left"
  },
  
  // 背景
  background: {
    "natural_landscape": "natural landscape background",
    "urban_background": "urban background",
    "simple_background": "simple background",
    "indoor_background": "indoor background",
    "virtual_background": "virtual background"
  },
  
  // 背景效果
  background_effect: {
    "dynamic_background": "dynamic background",
    "neon_light_background": "neon light background",
    "starry_sky_background": "starry sky background",
    "fog_mist_effect": "fog mist effect",
    "minimalist_background": "minimalist background"
  },
  
  // 背景模糊
  background_blur: {
    "slight_blur": "slight background blur",
    "strong_blur": "strong background blur",
    "haze_effect": "haze effect"
  }
};



export const promptMappings = {
  technicalParameterMappings,
  styleAndMoodMappings,
  characterMappings,
  environmentMappings
};

export default promptMappings;